import React from 'react';
import { withStyles } from 'material-ui/styles';
import { connect } from 'react-redux';
import { Button, ButtonGroup, Content, Dialog, DialogContainer, Heading } from '@adobe/react-spectrum';
import { CircleCheck, CircleX } from 'lucide-react';
import classnames from 'classnames';
import styles from './styles';
import { dateFormatter } from '../../../../common/utils';

class HealthCheckModal extends React.Component {
  handleOpenChange = (isOpen) => {
    this.props.onOpenChange(isOpen);
  };

  getCheckDetail = (check) => {
    const { translate } = this.props;
    const { name, passed, currentValue, expectedValue } = check;

    switch (name) {
      case 'TipWear':
      case 'Tip Wear':
        if (passed) return translate('health_check_tipwear_passed', { currentValue });
        return translate('health_check_tipwear_failed', { currentValue, expectedValue });

      case 'SoftwareVersion':
        if (!passed && !currentValue) return translate('health_check_software_no_device_version');
        if (passed && !expectedValue) return translate('health_check_software_no_version');
        if (passed) return translate('health_check_software_passed', { currentValue });
        return translate('health_check_software_failed', { currentValue, expectedValue });

      case 'Calibration':
      case 'Calibration Due': {
        if (!passed && !currentValue) return translate('health_check_calibration_no_date');
        const formattedDate = dateFormatter(currentValue);
        const values = {currentValue: formattedDate, expectedValue: formattedDate};
        if (passed) return translate('health_check_calibration_passed', values);
        return translate('health_check_calibration_failed', values);
      }

      case 'LastSync':
        if (!passed && !currentValue) return translate('health_check_lastsync_never');
        if (passed) return translate('health_check_lastsync_passed', { currentValue });
        return translate('health_check_lastsync_failed', { currentValue, expectedValue });

      case 'Last Activity':
        if (currentValue === null || currentValue === undefined) return translate('adapter_health_no_activity');
        if (passed) return translate('adapter_health_last_activity_passed', { currentValue });
        return translate('adapter_health_last_activity_failed', { currentValue, expectedValue });

      default:
        return currentValue || '';
    }
  };

  formatCheckName = (name) => {
    const {translate} = this.props;
    const checkNameKeys = {
      TipWear: 'health_check_name_tip_wear',
      SoftwareVersion: 'health_check_name_software_version',
      Calibration: 'health_check_name_calibration',
      LastSync: 'health_check_name_last_sync',
      'Calibration Due': 'health_check_name_calibration',
      'Last Activity': 'health_check_name_last_activity',
      'Tip Wear': 'health_check_name_tip_wear',
    };

    if (checkNameKeys[name]) {
      return translate(checkNameKeys[name]);
    }

    // Convert camelCase to space-separated words
    return name
      .replace(/([A-Z])/g, ' $1')
      .replace(/^[ ]/, '')
      .trim();
  };

  renderHealthTable = () => {
    const { classes, translate } = this.props;
    const { deviceHealth } = this.props;

    if (!deviceHealth || deviceHealth.length === 0) {
      return null;
    }

    return (
      <div className={classes.tableContainer}>
        <table className={classes.table}>
          <thead>
            <tr className={classes.tableHeaderRow}>
              <th className={classes.tableHeaderCell}>{translate('health_check_col_name')}</th>
              <th className={classes.tableHeaderCell}>{translate('status')}</th>
              <th className={classes.tableHeaderCell}>{translate('tab_details')}</th>
            </tr>
          </thead>
          <tbody>
            {deviceHealth.map((check, index) => (
              <tr key={index} className={classes.tableRow}>
                <td className={classnames(classes.tableCell, classes.checkName)}>
                  {this.formatCheckName(check.name)}
                </td>
                <td className={classes.tableCell}>
                  <span className={classnames({
                    [classes.statusPassed]: check.passed,
                    [classes.statusFailed]: !check.passed
                  })}>
                    {check.passed ? <CircleCheck size={24} /> : <CircleX size={24} />}
                  </span>
                </td>
                <td className={classes.tableCell}>{this.getCheckDetail(check)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  render() {
    const { classes, isOpen, translate } = this.props;

    return (
      <DialogContainer onDismiss={() => this.props.onOpenChange(false)}>
        {isOpen && (
          <Dialog>
            <Heading UNSAFE_className={classes.dialogHeading}>{translate('health_check_title')}</Heading>
            <Content>
              {this.renderHealthTable()}
            </Content>
            <ButtonGroup>
              <Button variant="secondary" onPress={() => this.props.onOpenChange(false)}>
                {translate('general_close')}
              </Button>
            </ButtonGroup>
          </Dialog>
        )}
      </DialogContainer>
    );
  }
}

export default connect()(withStyles(styles)(HealthCheckModal));
